import { createSelector } from 'reselect';

import { namespace, WorkerState } from '../models';
import { DEFAULT_GLOBAL_SETTINGS } from '@helpers/constants';

export const selectStore = (s: { [namespace]: WorkerState }) => s[namespace];

export const selectFeatureFlags = createSelector(
  selectStore,
  (s) => s.featureFlags
);

export const selectGlobalSettings = createSelector(
  selectStore,
  (s) => s.tdo?.details?.settings || DEFAULT_GLOBAL_SETTINGS
);

export const selectAutoInterpolationMax = createSelector(
  selectGlobalSettings,
  (s) => s.autoInterpolationMax
);

export const selectManualInterpolationMax = createSelector(
  selectGlobalSettings,
  (s) => s.manualInterpolationMax
);

export const selectInterpolationMaxStretch = createSelector(
  selectGlobalSettings,
  (s) => s.interpolationMaxStretch
);

export const selectFrameRate = createSelector(
  selectStore,
  (s) => s?.tdo?.details?.veritoneFile?.videoFrameRate
);

export const selectMediaDuration = createSelector(
  selectStore,
  (s) => s.mediaDuration
);

export const selectSelected = createSelector(
  selectStore,
  (s) => s.selectedPolyGroups
);

export const selectDataFetchedForDetectionType = createSelector(
  selectStore,
  (s) => s.dataFetchedForDetectionType
);

export const selectHistory = createSelector(selectStore, (s) => s.history);

export const selectBackgroundBlurEdits = createSelector(
  selectStore,
  (s) => s.backgroundBlurEdits
);
